import { Typography } from '@material-tailwind/react'
import { LoginForm } from './components/login-form'
import { useEffect } from 'react'
import { store } from '@/store'
import { fetchCurrentUser } from '@/store/slices/userSlice'
import { useNavigate } from 'react-router-dom'

export const SignIn = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const validateCurrentUser = async () => {
      try {
        const user = await store.dispatch(fetchCurrentUser()).unwrap()
        if (user.id) {
          navigate('/')
        }
      } catch (error) {
      }
    }

    validateCurrentUser()
  }, [])
  return (
    <div className='w-full h-full max-w-lg p-4 flex items-center my-0 mx-auto flex-col justify-center gap-16'>
      <section className='flex gap-10 flex-col justify-center items-center'>
        <img src="logo.svg" className='w-80' />

        <div>
          <Typography variant='h1'>
            Iniciar sesión
          </Typography>

          <Typography variant='h5' color='gray' className='font-normal'>
            Accede a tu cuenta de APS
          </Typography>
        </div>
      </section>

      <LoginForm />
    </div>
  )
}
